import React from "react";
import { useTranslation } from "react-i18next";
import AmpDropdown from "../../components/common/AmpDropdown/AmpDropdown";
import Com from "../../components/howAssessmentWorks/Com/Com";
import Frm from "../../components/howAssessmentWorks/Frm/Frm";
import Hos from "../../components/howAssessmentWorks/Hos/Hos";
import Mfr from "../../components/howAssessmentWorks/Mfr/Mfr";
import Mul from "../../components/howAssessmentWorks/Mul/Mul";
import Res from "../../components/howAssessmentWorks/Res/Res";
import Spb from "../../components/howAssessmentWorks/Spb/Spb";
import Spe from "../../components/howAssessmentWorks/Spe/Spe";
import LookingTodoNext from "../../components/landing/LookingTodoNext/LookingTodoNext";
import QuestionIcon from "../../components/common/Icons/QuestionIcon/QuestionIcon";

import "./HowAssessmentWorks.css";

export default function HowAssessmentWorks(): JSX.Element {

    const { t } = useTranslation('assessment');

	const [selectedOption, setSelectedOption] = React.useState<string>("Res");

	const onSelectionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setSelectedOption(event.target.value);
	}

	const changeFaqAnswer = (selectedType: string): React.ReactElement => {
		switch (selectedType) {
			case 'Res':
				return <Res/>;
			case 'Com':
				return <Com/>;
			case 'Farm':
				return <Frm/>;
			case 'Hos':
				return <Hos/>;
			case 'Forest':
				return <Mfr/>;
			case 'MultiRes':
				return <Mul/>;
			case 'SPBP':
				return <Spb/>;
			case 'SPE':
				return <Spe/>;
			default:
				return <Res/>;
		}
	}

	const dropdownOptions = [
		{
			value: "Res",
			text: t("property-dropdown.option-res") as string
		},
		{
			value: "Com",
			text: t("property-dropdown.option-com") as string
		},
		{
			value: "Farm",
			text: t("property-dropdown.option-farm") as string
		},
		{
			value: "Hos",
			text: t("property-dropdown.option-hos") as string
		},
		{
			value: "Forest",
			text: t("property-dropdown.option-forest") as string
		},
		{
			value: "MultiRes",
			text: t("property-dropdown.option-multi-res") as string
		},
		{
			value: "SPBP",
			text: t("property-dropdown.option-spbp") as string
		},
		{
			value: "SPE",
			text: t("property-dropdown.option-spe") as string
		}
	];

    return (
        <>
			<div className="page-container">
				<h2 className="assessment-title">{t("how-accessment-works") as string}</h2>
				<div className="assessment-content">
					<p>{t("explanation.paragraph-1") as string}</p>

					<p>{t("explanation.paragraph-2") as string}</p>
					
					<p>{t("explanation.paragraph-3") as string}</p>

					<p>{t("explanation.paragraph-4") as string}</p>
					
					<AmpDropdown className="type-select" value={selectedOption} onChange={onSelectionChange} options={dropdownOptions} label={t("property-dropdown.title") as string} id="howAssmentWorks" />
				</div>
				<div className="faq-outer-container">
					<div className="faq-inner-container">
						<div className="faq-image-container">
							<QuestionIcon className="faq-image" />
						</div>
						<div className="faq-answer">
							<div className="faq-answer-content">
							{changeFaqAnswer(selectedOption)}
							</div>
						</div>
					</div>
				</div>
				<div className="bottom-bar-container">
					<LookingTodoNext boxes={["vmpd", "bmn"]}/>
				</div>
			</div>
        </>
    )
}